export default __webpack_public_path__ + "static/media/visibility.0ec4837b.svg";